import { Dialog } from "vant";

/** 首页与精选页共用新消息提示；只打开常驻工作台，不导航、不建立客服会话。 */
export default {
  computed: {
    chatMessagePromptSuppressed() {
      const ui = this.$store?.state?.chatWorkbench;
      return /^\/(?:pc\/)?myxg\/messageCenter\/?$/u.test(this.$route?.path || "")
        || Boolean(ui?.open && !ui.docked);
    },
  },
  watch: {
    chatMessagePromptSuppressed(value) { if (value) this.dismissChatMessagePrompt(); },
    "$store.state.user.userInfo.token"() { this.dismissChatMessagePrompt(); },
  },
  beforeDestroy() { this.dismissChatMessagePrompt(); },
  deactivated() { this.dismissChatMessagePrompt(); },
  methods: {
    /** 关闭本组件持有的提示，避免误关页面中的订单或其他确认框。 */
    dismissChatMessagePrompt() {
      if (!this._chatMessagePromptActive) return;
      this._chatMessagePromptActive = false;
      this._chatMessagePromptEpoch = (this._chatMessagePromptEpoch || 0) + 1;
      if (typeof document !== "undefined" && document.querySelector(`.chat-new-message-prompt-${this._uid}`)) Dialog.close();
    },
    /** 提示期间进入聊天、切页或换号后，旧确认回调不能再次打开浮窗。 */
    async showChatMessagePrompt() {
      if (this.chatMessagePromptSuppressed || this._chatMessagePromptActive || this._isDestroyed || this._isBeingDestroyed || this._inactive) return;
      const epoch = this._chatMessagePromptEpoch = (this._chatMessagePromptEpoch || 0) + 1;
      const token = this.$store?.state?.user?.userInfo?.token;
      this._chatMessagePromptActive = true;
      sessionStorage.setItem("hasTip", 1);
      try {
        await Dialog.confirm({
          title: this.$t("pcHome.newMessages"),
          confirmButtonText: this.$t("pcHome.viewMessages"),
          confirmButtonColor: "#4689F2",
          className: `chat-new-message-prompt-${this._uid}`,
        });
        if (epoch !== this._chatMessagePromptEpoch || this.chatMessagePromptSuppressed
          || token !== this.$store?.state?.user?.userInfo?.token || this._isDestroyed || this._isBeingDestroyed) return;
        this._chatMessagePromptActive = false;
        this.$store.commit("chatWorkbench/open", { kind: "INBOX", expand: true });
      } catch { /* 取消或自动关闭提示不改变消息和已读状态。 */ }
      finally { if (epoch === this._chatMessagePromptEpoch) this._chatMessagePromptActive = false; }
    },
  },
};
